import type { BrowseDataAPISortingOption } from 'src/services/browse-data-api/types/BrowseDataAPISortingOption';

export const getSelectedSortOption = (sortingOptions: BrowseDataAPISortingOption[]) =>
  sortingOptions.find((option) => option.active) || null;
